import _ from 'lodash';

import './typeahead-with-tags.less';

export default angular.module('cian.newbuild.filter.typeaheadWithTags', [])
  .directive('typeaheadWithTags', () => ({
    restrict: 'E',
    template: require('./typeahead-with-tags.jade'),
    scope: {},
    bindToController: {
      items: '=?',
      source: '=',
      /**
       * Функция для получения данных
       * @param {string} query - текст для фильтрации вариантов
       * @return {Promise}
       */
      fetchItems: '&?',
      /**
       * Название фильтра (обязательно при запросе через API)
       * @type {string}
       * @example
       * specialty_types
       */
      filterParam: '@?',
      placeholder: '@?',
    },
    controller: [
      '$log',
      '$element',
      '$filter',
      'TagTitleService',
      function ($log, $element, $filter, TagTitleService) {
        const ctrl = this;
        ctrl.input = '';

        const isAsync = angular.isFunction(ctrl.fetchItems);
        ctrl.isAsync = isAsync;
        ctrl.ngModelOptions = isAsync ? { debounce: 300 } : {};

        const rejectAlreadySelected = items => _.reject(items,
          item => _.includes(ctrl.source.value, item.value)
        );

        /**
         * @param {string} query
         * @return {[] | Promise}
         */
        ctrl.getItems = (query) => {
          if (isAsync && query) {
            return ctrl.fetchItems({ $query: query })
              .then(rejectAlreadySelected);
          }

          if (angular.isArray(ctrl.items)) {
            return rejectAlreadySelected(
              $filter('filter')(ctrl.items, { text: query })
            );
          }
        };

        ctrl.arrowClick = e => {
          if (!ctrl.isOpen) {
            // Чтобы автокомплит не закрылся из-за клика вне инпута
            e.stopPropagation();
            $element.find('input').trigger('focus');
          }
        };

        ctrl.select = item => {
          ctrl.input = ''; // очищаем инпут
          ctrl.source.value = _.union(ctrl.source.value, [item.value]);

          // Если получаем данные от бэка, то запоминаем название для выбранного элемента
          if (isAsync) TagTitleService.saveTitle(ctrl.filterParam, item.value, item.text);
        };


        /* Тэги */

        ctrl.getText = val => isAsync ?
          TagTitleService.getTitle({ key: ctrl.filterParam, value: val }) :
          _.find(ctrl.items, { value: val }).text;

        ctrl.removeItem = val =>
          ctrl.source.value.splice(ctrl.source.value.indexOf(val), 1);
      }
    ],
    controllerAs: 'typeaheadWithTags',
  }))
  .name;



// WEBPACK FOOTER //
// ./src/serp/directives/typeahead-with-tags/typeahead-with-tags.dir.js